// extracted by mini-css-extract-plugin
export var dropdown = "_tl-0";
export var imageWrapper = "_tl-3";
export var itemNameContainer = "_tl-1";
export var productImage = "_tl-2";
export var spinnerWrapper = "_tl-4";